export const getConservatoryAlias = (conservatory, alias) => {
  let conservatoryAlias = "";
  switch (conservatory) {
    case "PULPET":
      conservatoryAlias = alias.bfcFrameTypeFira;
      break;
    case "PULPET50-50":
      conservatoryAlias = alias.bfcFrameTypeFira5050;
      break;
    case "FIRAXL":
      conservatoryAlias = alias.bfcFrameTypeFiraXL;
      break;
    case "SADEL":
      conservatoryAlias = alias.bfcFrameTypeGladja;
      break;
    case "SKAPA":
      conservatoryAlias = alias.bfcFrameTypeSkapa;
      break;
    case "DROMMA":
      conservatoryAlias = alias.bfcFrameTypeDromma;
      break;
    case "FIRAVINKEL":
      conservatoryAlias = alias.bfcFrameTypeFiraVinkel;
      break;
    case "TJUSA":
      conservatoryAlias = alias.bfcFrameTypeTjusa;
      break;
    case "ONSKA":
      conservatoryAlias = alias.bfcFrameTypeOnska;
      break;
    case "LYCKA":
      conservatoryAlias = alias.bfcFrameTypeLycka;
      break;
    default:
      break;
  }
  return conservatoryAlias;
};
